import { Component } from '@angular/core';

@Component({
    selector: 'app-asset-summary',
    templateUrl: './asset-summary.component.html',
    standalone: true
})
export class AssetSummaryComponent {
    get assetAddress() {
        return sessionStorage.getItem("connect.assetAddress");
    }

    get crmReference() {
        return sessionStorage.getItem("connect.crmReference");
    }
}
